/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Home_How_Step2Inputs */



/**
* | output |
* | --- |
* | "When a period ends, oneAI prices it: seats for the days they were active, add-ons, and AI usage above the included credit." |
*
* @param {Partner_Home_How_Step2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_how_step2 = /** @type {((inputs?: Partner_Home_How_Step2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_How_Step2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Endet ein Zeitraum, berechnet oneAI ihn: Plätze für die Tage, an denen sie aktiv waren, Zusatzpakete und KI-Nutzung über dem enthaltenen Guthaben.")
	return /** @type {LocalizedString} */ ("When a period ends, oneAI prices it: seats for the days they were active, add-ons, and AI usage above the included credit.")
});